import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import PortfolioPropertyDetail from "./PortfolioPropertyDetail";
import BSInput from "../../../common/js/components/BSInput";
import ErrorBoundary from "../../../common/js/components/ErrorBoundary";
import MultiAddInput from "../../../common/js/components/MultiAddInput";
import "./Portfolio.css";

const SwitchTitle = styled("span")({
    fontSize: 14,
    fontWeight: 600,
});

const TheSwitch = styled(Switch)({
    marginRight: 0,
});

const PortfolioForm = (props) => {
    const {
        data,
        dataPathPrefix,
        disableInputs,
        errors,
        handleAddArrayElement,
        handleDeleteArrayElement,
        handleUpdateArrayElement,
        onChange,
    } = props;

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                    <SwitchTitle>Portfolio Information</SwitchTitle>
                </div>
                <div>
                    <FormControlLabel
                        control={
                            <TheSwitch
                                checked={data.portfolioFlg === true ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                color="primary"
                                value="portfolioFlg"
                                disabled={disableInputs}
                            />
                        }
                    />
                </div>
            </div>
            {data.portfolioFlg && (
                <div>
                    <BSInput
                        id="portfolioName"
                        extraInputStyles={{ marginRight: "34px" }}
                        label="Portfolio"
                        disabled={disableInputs}
                        placeholder="Enter name"
                        error={errors.portfolioName}
                        value={data.portfolioName}
                        onChange={(e) => onChange(e.target.id, e.target.value)}
                    />
                    <ErrorBoundary>
                        <MultiAddInput
                            addButtonText="Add Portfolio Property"
                            disableInputs={disableInputs}
                            displayFirstWhenEmpty={true}
                            elements={data.portfolioProperties}
                            onAdd={() => handleAddArrayElement(dataPathPrefix + ".portfolioProperties")}
                            onUpdate={(e, index) =>
                                handleUpdateArrayElement(
                                    dataPathPrefix + ".portfolioProperties",
                                    index,
                                    e.target.id,
                                    e.target.value
                                )
                            }
                            render={(element, elementIndex) => (
                                <PortfolioPropertyDetail
                                    element={element}
                                    elementIndex={elementIndex}
                                    onDelete={(index) =>
                                        handleDeleteArrayElement(dataPathPrefix + ".portfolioProperties", index)
                                    }
                                    {...props}
                                />
                            )}
                        />
                    </ErrorBoundary>
                </div>
            )}
        </div>
    );
};

export default PortfolioForm;
